const api_root = process.env.BACKEND_URL ? process.env.BACKEND_URL : 'https://idot-trec.prairie.illinois.edu/'

export default function getBackendURL(api_path: string) {
	api_path = "/api" + api_path;
	return new URL(api_path, api_root).toString();
}
